<div class="wrapper">
    <div *ngIf="!loading" class="body">
        <img class="logo" src="../../../assets/img/logoitsi.png" alt="img login">
        <h4 class="mb-2">Introduzca el email del usuario que quiere restaurar su contraseña</h4>
        
        <div class="form-floating mb-3 mt-3">
            <input type="text" [(ngModel)]="username" autocomplete="false" class="form-control" placeholder="Ingrese usuario (email)">
            <label>Usuario</label>
        </div>

        <!-- Campo para ingresar la nueva contraseña -->
        <div class="form-floating mb-3">
            <input type="text" [(ngModel)]="password" autocomplete="false" class="form-control" placeholder="Ingrese nueva contraseña">
            <label>Nueva Contraseña</label>
            <!-- Botón para generar una contraseña aleatoria -->
            <button type="button" class="btn btn-secondary mt-2" (click)="generateRandomPassword()">Generar Contraseña Aleatoria</button>
        </div>

        <div class="d-grid gap-2">
            <button type="button" class="btn btn-primary btn-lg" (click)="resetpassword()">Aceptar</button>
        </div>
    </div>
    <app-spinner *ngIf="loading"></app-spinner>
</div>
